export function generatePrescriptionId(prescriptions: any[]): string {
  // Get current year (last 2 digits)
  const year = new Date().getFullYear().toString().slice(-2);
  
  // Get all prescriptions from this year
  const yearPrescriptions = prescriptions.filter(p => {
    const prescriptionDate = new Date(p.createdAt || p.created_at);
    return prescriptionDate.getFullYear().toString().slice(-2) === year;
  });
  
  // Get the highest sequence number for this year
  const maxSeq = yearPrescriptions.reduce((max, p) => {
    // Extract sequence from prescription ID if it exists
    const idMatch = p.id?.match(/PRES-(\d{2})-(\d{4})/);
    if (idMatch && idMatch[1] === year) {
      const seq = parseInt(idMatch[2]);
      return Math.max(max, seq);
    }
    return max;
  }, 0);
  
  // Generate next sequence number (4 digits)
  const nextSeq = (maxSeq + 1).toString().padStart(4, '0');
  
  // Combine to create ID in format: PRES-YY-XXXX
  return `PRES-${year}-${nextSeq}`;
}

export function formatPrescriptionId(id: string): string {
  // If it's already in the correct format, return as is
  if (id.match(/^PRES-\d{2}-\d{4}$/)) {
    return id;
  }
  
  // If it's a UUID, return a shortened version
  if (id.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i)) {
    return `PRES-${id.slice(0, 8).toUpperCase()}`;
  }
  
  // For any other format, return as is
  return id;
}

export function isValidPrescriptionId(id: string): boolean {
  return /^PRES-\d{2}-\d{4}$/.test(id);
} 